/*
 * VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

export interface UserConfig {
    id?: number;
    avatar_url?: string;
    firstname?: string;
    lastname?: string;
    mail?: string;
    totp_secret: string;
    tfa_enabled: boolean;
    rfc_limit: number;
    rfc_enabled: boolean;
    video_bridge: boolean;
    can_invite_users: boolean;
    has_invitation_rights: boolean;
    can_upgrade_to_org: boolean;
    can_manage_mcbs: boolean;
    organizationId: number;
    omemo: boolean;
    topics_view: TOPIC_VIEW;
    vnc_features?: string[];
    attachment_max_size?: any;
    auto_clean_trash: boolean;
    auto_clean_trash_period: number;
}



export enum TOPIC_VIEW {
  GRID = "grid",
  LIST = "list",
  TABLE = "table"
}

export enum EMPTY_STATE_TYPE {
  BUTTON = "button",
  SINGLE = "single"
}
